export default {
  app: {
    title: 'Accueil',
    description: 'Tableau de bord et vue d\'ensemble',
  },
  common: {
    title: 'Accueil',
    description: 'Tableau de bord et vue d\'ensemble',
  },
  filled: {
    greeting: 'Bonjour {name},',
    greetingNoName: 'Bonjour,',
    invitations: [
      'ravi de vous revoir.',
      'content de vous retrouver.',
      'heureux de vous retrouver ici.',
      'place au contenu.',
      'votre audience vous attend.',
    ],
    lastUpload: 'Votre dernier média a été ajouté {relative}, envie de continuer ?',
  },
  inviteBanner: {
    title: 'Invitez votre équipe',
    subtitle: 'Collaborez sur vos projets et partagez vos contenus en quelques clics.',
    cta: 'Inviter',
    later: 'Plus tard',
  },
  welcomeVideo: {
    title: 'Découvrez Videas en 2 minutes',
    subtitle: 'Importez, sous-titrez, diffusez et monétisez vos contenus — un tour complet de la plateforme.',
    watch: 'Regarder',
    dismiss: 'Masquer',
  },
  empty: {
    badge: 'Bienvenue sur Videas',
    greeting: 'Bonjour {name},',
    greetingNoName: 'Bonjour,',
    invitation: 'on commence ?',
    subtitle: 'Votre espace est vide pour le moment. Suivez les étapes ci-dessous pour le remplir et découvrir tout ce que Videas peut faire pour vous.',
    dropzone: {
      title: 'Déposez vos premiers fichiers ici',
      subtitle: 'Glissez-déposez depuis votre bureau, ou parcourez vos dossiers. Vidéos, images, sons, PDF — jusqu\'à 2 Go par fichier.',
      browse: 'Parcourir',
    },
    firstSteps: {
      lead: 'Quelques portes d\'entrée pour démarrer, dans l\'ordre que vous voulez.',
      afterImport: 'Après votre premier import',
      guide: 'Le guide des premiers pas',
    },
  },
  onboarding: {
    // Le chemin du retour. Il n'apparaît que tant qu'aucun média parlant n'a été
    // Surcouche audio : uniquement les phrases qui nomment le média.
    // `useOnboardingCopy` essaie `home.onboarding.audio.<clé>` avant la clé
    // d'origine, donc tout ce qui n'est pas ici reste dit une seule fois.
    // Pas de paramètre `{media}` : en français l'article fait partie du mot
    // (« votre vidéo » / « votre enregistrement », de genres différents), et une substitution produirait
    // des accords faux.
    audio: {
      tracks: {
        sharing: {
          label: 'Envoyer un enregistrement à quelqu\'un',
          goal: 'votre première écoute',
        },
        subtitles: {
          label: 'Transcrire un enregistrement',
          goal: 'votre transcription',
          deliverable: 'votre transcription',
        },
        websites: {
          // « podcast » est son mot à lui ; le livrable, lui, ne promet pas la
          // distribution : il n'existe aucun flux RSS.
          label: 'Mettre votre podcast en ligne',
          goal: 'votre podcast en ligne',
          deliverable: 'l\'adresse publique de votre page d\'écoute',
        },
        embeds: {
          label: 'Diffuser un épisode sur votre site',
        },
      },
      actions: {
        subtitle_generate: {
          title: 'Générer la transcription',
          cta: 'Générer la transcription',
          suggestion: 'Transcrire votre épisode',
        },
        share_statistics_read: {
          title: 'Voir votre première écoute',
        },
      },
      steps: {
        hints: {
          share_create: 'Privé, daté — et vous voyez qui écoute',
        },
      },
      scenes: {
        subtitle_generate: {
          title: 'Transcrire votre enregistrement',
          note: 'Environ 30 secondes pour 5 minutes d\'audio.',
          busyTitle: 'On écoute votre enregistrement',
          busyNote: 'Bien plus rapide que de le réécouter en entier.',
          doneNote: 'Votre transcription existe — il reste à la relire.',
          error: {
            line: 'On n\'a pas réussi à générer la transcription de cet enregistrement. Rien n\'a été décompté de votre solde.',
          },
        },
        subtitle_edit: {
          title: 'Relire votre transcription',
          line: 'L\'éditeur joue le son pendant que vous lisez. Les passages douteux sont signalés, le reste est déjà bon.',
          doneNote: 'Relue, corrigée, enregistrée.',
          error: {
            title: 'Scribe n\'a pas pu ouvrir votre enregistrement',
          },
        },
        share_create: {
          title: 'Envoyer votre enregistrement',
          error: {
            line: 'La demande n\'est pas arrivée jusqu\'au bout. Votre fichier, lui, n\'a pas bougé.',
          },
        },
        embed_code_copy: {
          line: 'Une ligne à coller dans votre page. Le lecteur s\'adapte à la largeur disponible, et les écoutes depuis votre site remontent ici.',
          error: {
            line: 'Votre fichier doit être encodé avant de pouvoir être intégré quelque part.',
          },
        },
        website_create: {
          // Un son n'a pas de vignette : sans pochette, la chaîne publiée est
          // une grille grise, et c'est le livrable qu'on lui montre à la fin.
          note: 'Votre adresse se terminera par .websites.videas.com. Prévoyez une pochette : un son n\'a pas d\'image.',
        },
        errors: {
          encodingFailed: {
            title: 'On n\'a pas réussi à encoder votre fichier',
            line: 'Le fichier est peut-être abîmé, ou dans un format qu\'on ne sait pas lire. Un MP3 passe à tous les coups.',
          },
        },
      },
      finish: {
        tracks: {
          subtitles: {
            title: 'Votre transcription est',
            highlight: 'prête.',
            line: 'Transcrite en quelques secondes, relue par vous. Exportez-la, ou gardez-la collée à l\'épisode.',
          },
          embeds: {
            line: 'Le code s\'adapte à la largeur de votre page, et les écoutes depuis votre site remontent dans l\'app.',
          },
        },
        suggestions: {
          subtitle_generate: 'Trente secondes, et votre lien se lit autant qu\'il s\'écoute.',
          share_create: 'Un lien privé, et vous voyez qui a écouté.',
          website_host_connect: 'monpodcast.fr, plutôt que monpodcast.websites.videas.com.',
        },
      },
    },
    locked: 'Après « {step} »',
    skipped: 'Passée — à faire quand vous voulez',
    host: {
      resume: 'on continue ?',
      done: 'bien joué.',
      goal: 'Votre objectif : {goal} — environ {minutes} min.',
    },
    router: {
      needsAsset: 'Importez d\'abord un média — on enchaîne juste après.',
      // L'import se coche dès que les octets sont là, l'encodage continue
      // derrière. Répondre « importe d'abord un média » à ce moment-là dit le
      // contraire de ce que la colonne vient d'annoncer.
      assetEncoding: 'Votre média finit d\'encoder — on enchaîne dès qu\'il est prêt.',
      needsShare: 'Créez d\'abord votre lien de partage.',
      needsChannel: 'Créez d\'abord votre chaîne.',
      needsWorkspace: 'Aucun espace de travail à ouvrir pour l\'instant.',
      notYetAvailable: 'Cette étape n\'est pas encore ouverte. On revient vous chercher dès qu\'elle l\'est.',
      failed: 'Ça n\'a pas voulu s\'ouvrir. Réessayez dans un instant, votre progression est gardée.',
    },
    steps: {
      title: 'Premiers pas',
      progressLabel: 'Progression : {done} sur {total}',
      dismiss: 'Masquer définitivement les premiers pas',
      // Étape fermée le temps que le média finisse : dire « Après « Importer
      // votre premier média » » serait faux, cette étape-là est déjà cochée.
      preparing: 'On prépare votre média',
      remainingOne: 'Encore une étape avant {goal}. Environ {minutes} min.',
      remaining: 'Encore {count} étapes avant {goal}. Environ {minutes} min.',
      finished: 'Terminé.',
      account: {
        title: 'Votre compte est prêt',
        hint: 'Bienvenue sur Videas',
      },
      state: {
        done: 'Fait',
      },
      // Étapes cochées dont le travail continue en arrière-plan.
      working: {
        asset_upload: 'Encodage en cours — vous pouvez continuer',
      },
      hints: {
        asset_upload: 'Glissez-le, ou parcourez vos dossiers',
        subtitle_generate: 'Plus de 100 langues, détection automatique',
        subtitle_edit: 'L\'éditeur cale le texte sur l\'audio',
        share_create: 'Privé, daté — et vous voyez qui regarde',
        share_statistics_read: 'Qui l\'a ouvert, combien de temps, sur quel appareil',
        website_create: 'Un modèle, un nom, une couleur',
        website_publish: 'Elle naît en brouillon — à vous de l\'ouvrir',
        embed_code_copy: 'Une ligne à coller dans votre page',
        member_invite: 'Chacun retrouve les mêmes médias',
        embed_preset_save: 'Couleur, logo, comportement — pour tous vos lecteurs',
        website_host_connect: 'Votre adresse à vous, plutôt que celle de Videas',
      },
    },
    tracks: {
      sharing: {
        label: 'Envoyer une vidéo à quelqu\'un',
        goal: 'votre première vue',
        deliverable: 'le lien de partage',
      },
      subtitles: {
        label: 'Sous-titrer une vidéo',
        goal: 'vos sous-titres',
        deliverable: 'le fichier .srt',
      },
      websites: {
        label: 'Mettre une chaîne en ligne',
        goal: 'votre chaîne en ligne',
        deliverable: 'l\'adresse publique',
      },
      embeds: {
        label: 'Diffuser un média sur votre site',
        goal: 'votre code d\'intégration',
        deliverable: 'le code à coller',
      },
    },
    actions: {
      // « Média » et pas « vidéo » : la zone de dépôt accepte les sons, les
      // images et les PDF, et le parcours ne demande jamais le type — il prend
      // le dernier fichier importé. Promettre « vidéo » ici contredisait la note
      // de la scène, qui liste les quatre types sur le même écran.
      asset_upload: {
        title: 'Importer votre premier média',
        cta: 'Importer un média',
      },
      subtitle_generate: {
        title: 'Générer les sous-titres',
        cta: 'Générer les sous-titres',
        suggestion: 'Sous-titrer votre vidéo',
      },
      subtitle_edit: {
        title: 'Relire dans Scribe',
        cta: 'Ouvrir Scribe',
      },
      share_create: {
        title: 'Créer un lien de partage',
        cta: 'Créer le lien',
        suggestion: 'Envoyer le lien',
      },
      share_statistics_read: {
        title: 'Voir votre première vue',
        cta: 'Voir les statistiques',
      },
      website_create: {
        title: 'Créer votre chaîne',
        cta: 'Créer votre chaîne',
      },
      website_publish: {
        title: 'Publier votre chaîne',
        cta: 'Publier votre chaîne',
      },
      embed_code_copy: {
        title: 'Copier votre code d\'intégration',
        cta: 'Récupérer le code',
      },
      member_invite: {
        title: 'Inviter votre équipe',
        cta: 'Inviter des collègues',
      },
      embed_preset_save: {
        title: 'Régler le lecteur',
        cta: 'Ouvrir les réglages du lecteur',
        suggestion: 'Régler le lecteur',
      },
      website_host_connect: {
        title: 'Brancher votre domaine',
        cta: 'Brancher votre domaine',
        suggestion: 'Brancher votre domaine',
      },
    },
    scenes: {
      eyebrow: 'Étape {current} sur {total}',
      bonusEyebrow: 'Pendant que vous y êtes',
      doneEyebrow: 'C\'est fait',
      errorEyebrow: 'Ça coince',
      busyNote: 'On s\'en occupe, restez par ici.',
      errorNote: 'Si ça recommence, écrivez-nous depuis l\'aide — on regarde avec vous.',
      asset_upload: {
        title: 'Votre premier média',
        line: 'Glissez un fichier depuis votre bureau, ou parcourez vos dossiers. On s\'occupe de l\'encodage.',
        cta: 'Choisir un fichier',
        note: 'Vidéos, images, sons, PDF — jusqu\'à 2 Go par fichier.',
        busyTitle: 'On récupère votre fichier',
        busyLine: 'Votre fichier est en train d\'arriver. Restez sur cette page : fermer l\'onglet interromprait l\'envoi.',
        busyNote: 'Dès qu\'il est passé, on enchaîne — l\'encodage, lui, se termine pendant que vous avancez.',
        doneNote: 'C\'est encodé et prêt à servir.',
        error: {
          title: 'Votre import n\'est pas allé au bout',
          line: 'Le transfert s\'est interrompu en chemin. Votre fichier est intact sur votre ordinateur, rien n\'est perdu.',
          cta: 'Reprendre l\'import',
        },
      },
      subtitle_generate: {
        title: 'Sous-titrer votre vidéo',
        line: 'Videas détecte la langue, découpe les phrases et les cale sur l\'audio. Vous repassez derrière pour corriger ce que vous voulez.',
        cta: 'Choisir la langue et générer',
        note: 'Environ 30 secondes pour 5 minutes de vidéo.',
        busyTitle: 'On écoute votre vidéo',
        busyLine: 'La transcription tourne. Vous pouvez aller faire autre chose, on vous retrouve ici.',
        busyNote: 'Bien plus rapide que de la regarder en entier.',
        doneNote: 'Vos sous-titres existent — il reste à les relire.',
        error: {
          title: 'La transcription n\'a rien produit',
          line: 'On n\'a pas réussi à générer les sous-titres de cette vidéo. Rien n\'a été décompté de votre solde.',
          cta: 'Relancer la transcription',
        },
      },
      subtitle_edit: {
        title: 'Relire vos sous-titres',
        line: 'L\'éditeur joue la vidéo pendant que vous lisez. Les passages douteux sont signalés, le reste est déjà bon.',
        cta: 'Ouvrir Scribe',
        note: 'Vos corrections sont enregistrées au fil de la frappe.',
        doneNote: 'Relus, corrigés, enregistrés.',
        error: {
          title: 'Scribe n\'a pas pu ouvrir votre vidéo',
          line: 'L\'éditeur n\'a pas réussi à charger la piste audio. C\'est le plus souvent passager.',
          cta: 'Ouvrir Scribe à nouveau',
        },
      },
      share_create: {
        title: 'Envoyer votre vidéo',
        line: 'Un lien privé, avec date d\'expiration, mot de passe et limite d\'ouvertures si vous voulez. Chaque ouverture remonte dans vos statistiques.',
        cta: 'Créer le lien de partage',
        note: 'Le lien expire dans 7 jours par défaut.',
        doneNote: 'Votre lien est prêt — il ne reste qu\'à l\'envoyer.',
        error: {
          title: 'Le lien n\'a pas été créé',
          line: 'La demande n\'est pas arrivée jusqu\'au bout. Votre vidéo, elle, n\'a pas bougé.',
          cta: 'Créer le lien à nouveau',
        },
      },
      share_statistics_read: {
        // « ouvert », pas « regardé » : le compteur s'incrémente au chargement
        // de la page de partage (plan § 8). Les trois autres lignes de ce bloc
        // disaient déjà « ouverture » ; seul le titre promettait une lecture.
        title: 'Voir qui a ouvert votre lien',
        line: 'Chaque ouverture de votre lien est comptée : quand, combien de temps, sur quel appareil. Tous vos liens vivent au même endroit.',
        cta: 'Ouvrir mes partages',
        note: 'En attente de la première ouverture.',
        doneNote: 'Votre lien a été ouvert : la boucle est complète.',
        error: {
          title: 'Vos statistiques ne se chargent pas',
          line: 'Le service de mesure n\'a pas répondu. Vos ouvertures continuent d\'être comptées, rien ne se perd.',
          cta: 'Réessayer',
        },
      },
      embed_code_copy: {
        title: 'Récupérer votre code d\'intégration',
        line: 'Une ligne à coller dans votre page. Le lecteur s\'adapte à la largeur disponible, et les lectures depuis votre site remontent ici.',
        cta: 'Récupérer le code',
        note: 'Script ou iframe, au choix.',
        doneNote: 'Le code est copié — il n\'attend plus que votre page.',
        error: {
          title: 'Le code n\'a pas pu être généré',
          line: 'Votre vidéo doit être encodée avant de pouvoir être intégrée quelque part.',
          cta: 'Réessayer',
        },
      },
      website_create: {
        title: 'Créer votre chaîne',
        line: 'Vous choisissez un modèle — il décide de la structure du site, pas seulement des couleurs — puis un nom et une couleur. Vos médias remplissent le reste.',
        cta: 'Créer ma chaîne',
        note: 'Votre adresse se terminera par .websites.videas.com.',
        busyTitle: 'On monte votre chaîne',
        busyLine: 'On assemble les pages, le menu et votre catalogue.',
        busyNote: 'Quelques secondes, pas plus.',
        doneNote: 'Votre chaîne existe. Elle est encore en brouillon.',
        error: {
          title: 'Votre chaîne n\'a pas été créée',
          line: 'La création s\'est arrêtée en chemin. Rien n\'a été publié, vos médias sont intacts.',
          cta: 'Recommencer',
        },
      },
      website_publish: {
        title: 'Publier votre chaîne',
        line: 'Votre chaîne existe mais reste en brouillon : personne ne la voit encore. Vous pourrez la repasser en brouillon quand vous voulez.',
        cta: 'Publier ma chaîne',
        note: 'Publier une chaîne, c\'est un abonnement à {price} par mois.',
        noteContract: 'Publier une chaîne fait partie de votre contrat : rien n\'est débité ici.',
        // The fee negotiated to zero for this organization.
        noteOffered: 'Votre chaîne vous est offerte : rien n\'est débité pour elle.',
        busyTitle: 'On met votre chaîne en ligne',
        busyLine: 'On publie les pages et on ouvre l\'adresse au public.',
        busyNote: 'Quelques secondes, pas plus.',
        doneNote: 'Elle est en ligne, à son adresse publique.',
        error: {
          title: 'La publication n\'est pas passée',
          line: 'Votre chaîne est restée en brouillon : rien n\'a été montré au public.',
          cta: 'Publier à nouveau',
        },
      },
      member_invite: {
        title: 'Inviter votre équipe',
        line: 'Chaque personne invitée retrouve votre espace, ses dossiers et ses partages. Vous choisissez son rôle : lecteur, éditeur ou administrateur.',
        cta: 'Inviter mon équipe',
        note: 'Si ce n\'est pas le moment, on la garde de côté.',
        doneNote: 'Votre invitation est partie.',
        error: {
          title: 'L\'invitation n\'est pas partie',
          line: 'L\'adresse est peut-être mal écrite, ou la personne fait déjà partie de votre organisation.',
          cta: 'Réessayer l\'invitation',
        },
      },
      embed_preset_save: {
        title: 'Régler l\'allure du lecteur',
        line: 'Couleur, logo, comportement de lecture. Ça devient votre lecteur par défaut : toutes vos intégrations suivront.',
        cta: 'Personnaliser le lecteur',
        note: 'Modifiable à tout moment, sans retoucher votre code.',
        doneNote: 'Votre préréglage est enregistré.',
        error: {
          title: 'Les réglages du lecteur ne s\'ouvrent pas',
          line: 'L\'éditeur de préréglage n\'a pas répondu. Vos intégrations gardent leur allure actuelle.',
          cta: 'Réessayer',
        },
      },
      website_host_connect: {
        title: 'Brancher votre domaine',
        line: 'Votre adresse à vous, à la place de celle qu\'on vous a donnée. Vous ajoutez deux enregistrements chez votre hébergeur, on vérifie le reste.',
        cta: 'Brancher mon domaine',
        note: 'Un domaine branché, c\'est {domainPrice} par mois en plus.',
        noteContract: 'Brancher un domaine fait partie de votre contrat : rien n\'est débité ici.',
        noteOffered: 'Un domaine branché vous est offert : rien n\'est débité pour lui.',
        doneNote: 'Votre domaine répond.',
        error: {
          title: 'Votre domaine n\'a pas pu être branché',
          line: 'La vérification a échoué. Votre chaîne reste joignable à son adresse actuelle.',
          cta: 'Réessayer',
        },
      },
      errors: {
        uploadFailed: {
          title: 'Votre import s\'est arrêté en route',
          line: 'La connexion a lâché avant la fin du transfert. Votre fichier est intact sur votre ordinateur.',
          cta: 'Reprendre l\'import',
          ctaNewFile: 'Importer un autre fichier',
          ctaNewImport: 'Importer à nouveau',
          ctaTopUp: 'Recharger le solde',
          lines: {
            network: 'La connexion a lâché avant la fin du transfert. Vérifiez votre réseau : le transfert reprend là où il s\'est arrêté, votre fichier est intact sur votre ordinateur.',
            interrupted: 'Le transfert s\'est interrompu en route. Reprenez-le : il repartira de ce que le serveur a déjà reçu.',
            tooLarge: 'Ce fichier dépasse la taille qu\'on accepte. Essayez avec une version plus légère.',
            refused: 'Le serveur a refusé ce fichier. Vérifiez que c\'est bien un média lisible : un MP4 ou un MP3 passe à tous les coups.',
            forbidden: 'Vous n\'avez plus le droit d\'ajouter des fichiers ici. Votre session a peut-être expiré : reconnectez-vous.',
            destinationGone: 'L\'espace où allait votre fichier n\'existe plus. Importez-le à nouveau : il ira dans un espace qui existe.',
            rateLimited: 'Trop de demandes d\'un coup. Attendez un instant, puis reprenez l\'import.',
            creditsExhausted: 'Le solde de crédits de votre organisation ne couvre pas cet import. Rechargez-le : l\'import repartira ensuite.',
            budgetExceeded: 'Une limite de dépenses fixée pour votre organisation bloque cet import. La personne qui gère la facturation peut la relever.',
            session: 'L\'envoi a expiré côté serveur. Relancez-le : il repartira du début.',
            timedOut: 'Le serveur a cessé d\'attendre avant la fin du transfert. Reprenez l\'import dans un instant ; une connexion plus stable aide.',
            server: 'Notre serveur n\'a pas pu recevoir votre fichier. Réessayez dans un instant ; si ça continue, écrivez au support.',
          },
        },
        // Su dès l'encodage : la sonde n'a trouvé aucune piste sonore. On ferme
        // l'étape avant la modale plutôt que de laisser lancer une génération
        // qui reviendra bredouille.
        noSpeech: {
          title: 'Ce média n\'a pas de son',
          line: 'Il n\'y a aucune piste sonore à écouter, donc rien à transcrire. Envoyez un contenu où quelqu\'un parle et on s\'en occupe.',
          cta: 'Importer un autre média',
        },
        encodingFailed: {
          title: 'On n\'a pas réussi à encoder votre vidéo',
          line: 'Le fichier est peut-être abîmé, ou dans un format qu\'on ne sait pas lire. Un MP4 passe à tous les coups.',
          cta: 'Importer un autre fichier',
        },
        transcriptionEmpty: {
          title: 'On n\'a entendu personne parler',
          line: 'La transcription est revenue vide : la piste audio est peut-être muette, ou la langue mal détectée.',
          cta: 'Choisir la langue à la main',
        },
        dnsUnresolved: {
          title: 'Votre domaine ne pointe pas encore vers nous',
          line: 'Les enregistrements DNS mettent parfois quelques heures à se propager. Votre chaîne reste joignable à son adresse actuelle.',
          cta: 'Vérifier à nouveau',
        },
      },
    },
    finish: {
      eyebrow: 'Voilà, {name}. Vous savez faire.',
      eyebrowNoName: 'Voilà. Vous savez faire.',
      copy: 'Copier',
      copied: 'Copié',
      open: 'Ouvrir',
      acknowledge: 'Aller à mon accueil',
      acknowledgeChannel: 'Aller à ma chaîne',
      note: 'Ces premiers pas quittent votre accueil. Vous pouvez les relancer depuis {help}.',
      noteHelpLink: 'l\'aide',
      cost: 'Votre chaîne : {price} par mois, sans engagement.',
      costOffered: 'Votre chaîne vous est offerte.',
      costDetail: 'Voir le détail',
      suggestionCta: 'Le faire',
      suggestionDone: 'C\'est fait.',
      tracks: {
        sharing: {
          // Le compteur s'incrémente à l'ouverture du lien, pas à la lecture
          // (plan § 8) : « regardé » promettrait une mesure qu'on n'a pas.
          title: 'Quelqu\'un a',
          highlight: 'ouvert votre lien.',
          line: 'Importer, envoyer, mesurer : la boucle est complète. Tout ce que vous enverrez désormais remontera au même endroit.',
        },
        subtitles: {
          title: 'Vos sous-titres sont',
          highlight: 'prêts.',
          line: 'Transcrits en quelques secondes, relus par vous. Exportez-les, ou gardez-les collés à la vidéo.',
        },
        websites: {
          title: 'Votre chaîne est',
          highlight: 'en ligne.',
          line: 'Votre catalogue est publié à cette adresse. Vous pourrez y brancher votre propre domaine quand vous voulez.',
        },
        embeds: {
          title: 'Votre lecteur est',
          highlight: 'prêt à coller.',
          line: 'Le code s\'adapte à la largeur de votre page, et les lectures depuis votre site remontent dans l\'app.',
        },
      },
      suggestions: {
        subtitle_generate: 'Trente secondes, et votre lien se regarde beaucoup mieux.',
        share_create: 'Un lien privé, et vous voyez qui a regardé.',
        website_host_connect: 'moncours.fr, plutôt que moncours.websites.videas.com.',
        embed_preset_save: 'Couleur, logo, comportement — ça devient votre lecteur par défaut.',
      },
    },
    skip: 'Passer',
    // « ouvert votre lien » et non « regardé votre vidéo » : le compteur s'incrémente
    // au chargement de la page de partage, avant toute lecture (plan § 8).
    toasts: {
      firstView: 'Quelqu\'un vient d\'ouvrir votre lien.',
      transcribed: '{media} transcrites en {seconds} s.',
      seconds: '{n} s',
      minutes: '{n} min',
      minutesSeconds: '{m} min {s}',
    },
    questions: {
      counter: 'Question {current} sur {total}',
      done: 'Terminer',
      track: {
        question: 'Que voulez-vous faire en premier ?',
        hint: 'On vous guide jusqu\'au bout.',
        note: '≈ {minutes} min · vous repartez avec {deliverable}',
        // Aucun objectif proposé : personne ne peut rien déposer ici, donc aucune
        // piste ne se joue. On le dit, plutôt que de montrer une liste vide.
        none: 'Aucun parcours n\'est ouvert dans cet espace pour l\'instant. Demandez les droits d\'import à votre administrateur, et revenez.',
        // Les deux puces au-dessus des objectifs. Elles ne créent pas de piste :
        // elles choisissent le vocabulaire des quatre mêmes objectifs.
        mediaLabel: 'Type de média',
        media: {
          video: 'Vidéo',
          audio: 'Audio',
        },
      },
      team: {
        question: 'Êtes-vous seul(e) sur Videas ?',
        hint: 'Si vous êtes en équipe, on ajoute une étape pour inviter vos collègues.',
        options: {
          solo: 'Seul(e), pour l\'instant',
          team: 'Avec une équipe',
        },
      },
      source: {
        question: 'Comment nous avez-vous connus ?',
        hint: 'Dernière question, et elle ne change rien à votre parcours.',
        specify: 'Dites-nous en deux mots',
        options: {
          search: 'Recherche en ligne',
          recommendation: 'Recommandation / bouche-à-oreille',
          social: 'Réseaux sociaux',
          sales: 'Contact commercial',
          article: 'Article (blog, presse...)',
          tender: 'Appel d\'offres',
          other: 'Autre',
        },
      },
    },
  },
  statistics: {
    title: 'Statistiques',
    subtitle: 'Gérez vos quotas et comprenez votre audience',
    consumption: 'Consommation',
    lastMonth: 'Dernier mois',
    thisMonth: 'ce mois',
    vsPreviousPeriod: 'vs période précédente',
    vsLastMonth: 'vs mois dernier',
    videoStorage: {
      title: 'Stockage vidéos',
    },
    otherFiles: {
      title: 'Autres fichiers',
    },
    views: {
      title: 'Vues (30 jours)',
    },
    bandwidth: {
      title: 'Bande passante',
    },
    storageUsed: {
      title: 'Stockage utilisé',
      detail: '{videos} de vidéo · {audios} d\'audio',
    },
    distribution: {
      title: 'Répartition des assets',
      unit: 'fichiers',
    },
    totalAssets: '{count} fichiers',
    fileCount: '{count} fichiers',
    segments: {
      images: 'Images',
      audios: 'Audios',
      docs: 'Docs',
    },
  },
  apps: {
    title: 'Nos outils',
    description: 'Explorez nos outils pour créer, gérer et partager vos contenus.',
    comingSoon: 'À venir',
    open: 'Ouvrir',
    items: {
      videoGenerator: {
        title: 'Générateur vidéo',
        description: 'Créez des vidéos à partir de templates',
      },
    },
  },
  blog: {
    title: 'Depuis le blog',
    description: 'Suivez notre actualité, nos nouveautés et nos conseils vidéo.',
    viewAll: 'Lire le blog',
  },
  tutorials: {
    title: 'Apprenez en 5 minutes',
    viewAll: 'Voir tous les tutoriels',
    items: {
      shareLink: {
        title: 'Partager une vidéo par lien',
        excerpt: 'Créez un lien en trois clics et choisissez qui peut regarder : expiration, mot de passe, téléchargement.',
      },
      automaticSubtitles: {
        title: 'Générer des sous-titres automatiques',
        excerpt: 'Scribe transcrit vos vidéos en quelques minutes, dans plus de 100 langues.',
      },
      createChannel: {
        title: 'Créer une chaîne vidéo',
        excerpt: 'Six questions en deux minutes, et votre web TV est en ligne sur son propre sous-domaine.',
      },
    },
  },
  faq: {
    items: {
      monetization: {
        question: 'Comment monétiser votre contenu ?',
        answer: 'Vous pouvez monétiser vos vidéos via des ventes directes, des abonnements, ou des intégrations sur une chaîne payante.',
      },
      addContent: {
        question: 'Comment ajouter du contenu sur ma chaîne ?',
        answer: 'Cliquez sur « Ajouter une vidéo » depuis votre tableau de bord, ou glissez-déposez vos fichiers directement.',
      },
      secureSharing: {
        question: 'Est-ce que je peux partager une vidéo à une personne de façon sécurisée ?',
        answer: 'Oui, vous pouvez générer un lien privé avec mot de passe ou durée de validité.',
      },
      embedVideos: {
        question: 'Est-ce que je peux intégrer des vidéos Videas sur mon site internet ?',
        answer: 'Bien sûr. Chaque vidéo peut être intégrée via un code embed responsive.',
      },
      addSubtitles: {
        question: 'Comment ajouter des sous-titres à ma vidéo ?',
        answer: 'Rendez-vous dans l\'onglet « Sous-titres » d\'une vidéo pour importer ou générer automatiquement des fichiers.',
      },
    },
  },
  assets: {
    title: 'Médias récents',
    description: 'Accédez rapidement à vos derniers fichiers pour les organiser, les partager ou les analyser.',
    emptyState: {
      title: 'Aucun média récent',
      description: 'Importez votre premier fichier pour le voir apparaître ici.',
      descriptionNoUpload: 'Les médias des espaces auxquels vous avez accès apparaîtront ici.',
      uploadButton: 'Importer des médias',
    },
    status: {
      uploading: 'Envoi en cours…',
      uploadingPercent: 'Envoi en cours… {percent} %',
      processing: 'Préparation…',
      stepPercent: '{step} · {percent} %',
      failed: 'Échec du traitement',
      interrupted: 'Import interrompu',
      interruptedReason: 'Le fichier n\'est jamais arrivé : son envoi s\'est arrêté avant la fin. Ouvrez le média pour l\'envoyer à nouveau.',
      awaitingCredit: 'En attente de crédit',
      awaitingCreditReason: 'Le crédit ne couvre pas le premier mois de stockage de cette vidéo. Rechargez-le : l\'encodage reprendra de lui-même. Sans recharge, elle part à la corbeille au bout de sept jours.',
    },
  },
}
